import ViewQrCode from "./ViewQrCode";

export default ViewQrCode